import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { Event } from '../types';
import { showNotification } from '@/utils/notificationUtils';
export type SaveServiceDTO = {
  data: Event;
};

export const deleteService = ({ data }: SaveServiceDTO) => {
  return axios.delete(
    data.isRoomBooking
      ? `/business/${data.slugName}/booking/cancel/token/${data.token}`
      : `/business/${data.slugName}/appointment/cancel/token/${data.token}`,
    {
      params: { tz: data.tz },
    }
  );
};

type UseDeleteServiceOptions = {
  config?: MutationConfig<typeof deleteService>;
};

export const useDeleteService = ({ config }: UseDeleteServiceOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onMutate: async (deletedDiscussion) => {
      await queryClient.cancelQueries('appointments');

      const previousDiscussions = queryClient.getQueryData<Event[]>('appointments');

      queryClient.setQueryData(
        'appointments',
        previousDiscussions?.filter((discussion) => discussion.id !== deletedDiscussion.data?.id)
      );

      return { previousDiscussions };
    },
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Appointment Deleted',
      });
    },
    ...config,
    mutationFn: deleteService,
  });
};
